<template>
    <main class="form-signin">
        <form>
            <img class="mb-4" src="../assets/logo.png" alt="Logo" width="200" height="110">

            <div class="form-floating">
                <input type="email" class="form-control" id="email" placeholder="Email" v-model="user.email">
                <label for="email">Email</label>
            </div>

            <div class="form-floating">
                <input type="password" class="form-control" id="password" placeholder="Password" v-model="user.password">
                <label for="password">Password</label>
            </div>
            <button class="w-100 btn btn-lg btn-primary" type="button" @click="loginUser">Login</button>
            <p class="mt-5 mb-3 text-muted">&copy; GOFAR</p>
        </form>
    </main>
</template>

<script>
const localStorageHelper = require('../helpers/local-storage');
export default {
    name: 'Login',
    data() {
        return {
            user: {
                email: '',
                password: ''
            }
        }
    },
    methods: {
        async loginUser(){
          await this.$store.dispatch('loginUser', this.user);
          if (this.$store.state.loggedInUser) {
            localStorageHelper.setLoggedInUser(this.$store.state.loggedInUser);
            const role = localStorageHelper.getRole();
            if (typeof role === 'string' && role === 'admin') {
              await this.$router.push({path: '/admin'});
            } else {
              await this.$router.push({path: '/dashboard'});
            }
          } else {
            this.$notify({
              title: 'Fail!',
              text: 'Login failed! Check your credentials and try again',
              type: 'error',
              duration: 10000
            });
          }
        }

    }
}
</script>

<style scoped>
.form-signin {
  max-width: 330px;
  padding: 15px;
  margin: auto;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
